/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.1.0
 */
import { FC, Fragment } from 'react';

import getCellValue from '../../../helpers/getCellValue';
import { EColumnBalance } from '../../../types/columnTypes';
import {
    TableBalanceCurrencyStyled,
    TableBalanceDateStyled,
    TableBalanceValueStyled,
} from '../styled/TableBalanceStyled';
import {
    TableTextDefaultValueStyled,
    TableTextTooltipStyled,
} from '../styled/TableBlockStyled';

export interface ITableBalanceBlockProps {
    balanceType?: EColumnBalance;
    className?: string;
    currency?: string;
    date?: string;
    defaultValue: string;
}

export interface IStyledProps {
    balanceType?: EColumnBalance;
}

const TableBalanceBlock: FC<ITableBalanceBlockProps> = props => {
    const value = getCellValue(props.children);
    return (
        <Fragment>
            {
                value ?
                    <Fragment>
                        <TableTextTooltipStyled>
                            <TableBalanceValueStyled
                                balanceType={props.balanceType}
                            >
                                {value}
                            </TableBalanceValueStyled>
                            {
                                !!props.currency &&
                                <TableBalanceCurrencyStyled>
                                    {props.currency}
                                </TableBalanceCurrencyStyled>
                            }
                        </TableTextTooltipStyled>
                        {
                            !!props.date &&
                            <TableTextTooltipStyled>
                                <TableBalanceDateStyled>
                                    {props.date}
                                </TableBalanceDateStyled>
                            </TableTextTooltipStyled>
                        }
                    </Fragment>
                :
                <TableTextDefaultValueStyled>
                    {props.defaultValue}
                </TableTextDefaultValueStyled>
            }
        </Fragment>
    );
};

TableBalanceBlock.defaultProps = {
    defaultValue: '',
};

export default TableBalanceBlock;
